import React from "react";
import Slider from "react-slick";
import { Slide } from "react-reveal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settings } from "../reusables/carousel";
import CarCard from "../reusables/CarCard";
import scroll from "../../assets/images/icons/double-arrow-bottom-icon.svg";
import s4 from "../../assets/images/content/3.png";
import s6 from "../../assets/images/content/s4.jpg";
import Cta from "../reusables/Cta";

const HomeHero = () => {
  return (
    <section className="hero">
      <div className="large">
        <div className="carous">
          <div className="slider-items-container center-slide-arrows">
            <Slider {...settings}>
              <CarCard bgImg={s6}>
                <div className="hero-content-container">
                  <div className="hero-content-inner centered">
                    <div className="hero-body centered-inner">
                      <div className="hero-body-head">
                        <Slide top>
                          <p className="boldTitle">Nexus Events Uganda</p>
                        </Slide>
                        <Slide bottom>
                          <h1 className="margin-top-20">
                            Maximum experience &amp; value for your money!
                          </h1>{" "}
                        </Slide>
                        <Cta />
                      </div>
                    </div>
                  </div>
                </div>
              </CarCard>
              <CarCard bgImg={s4}>
                <div className="hero-content-container">
                  <div className="hero-content-inner centered">
                    <div className="hero-body centered-inner">
                      <div className="hero-body-head">
                        <Slide top>
                          <p className="boldTitle">Nexus Events Uganda</p>
                        </Slide>
                        <Slide bottom>
                          <h1 className="margin-top-20">
                            Delighting your event's experience!
                          </h1>{" "}
                        </Slide>
                        <Cta />
                      </div>
                    </div>
                  </div>
                </div>
              </CarCard>
            </Slider>
          </div>
        </div>
        <div className="scroll-container">
          <img src={scroll} alt="Double Bottom Arrows" />
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
